import styled from 'styled-components'

export const RecipePage = styled.main` 
    position: relative;
    min-height: 300px;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`